'use es6';

export const PUBLIC = 'PUBLIC';
export const APP = 'APP';